import moment from "moment";

const data = moment();
const dataAtual = data.format('DD/MM/YYYY');

export interface Tickets {
  protocolo : string | null,
  chamado: string | null,
  titulo: string,
  tipo: number,
  cnpjLicenciado:string,
  categoria?:string,
  urgencia:string,
  solicitante:solicitante | null,
  nomeSolicitante:string,
  status : string,
  abertura: string,
  previsaoSolucao : string,
  dataEncerramento: string,
  problema: string,
  propostaDeSolucao: string,
  custoSeNaoImplementado: string,
  embasamento: string,
  equipeResponsavel: string,
  modulo: number,

  //Novos campos neoassist
  IdCategoria:string,
  Email:string,
  CpfFieldU:string,
  ProtocoloFieldH:string,
  dataPrevisao:string,
  image: [], 
}

export enum Equipe {
  Default = 'Produto RH, Ponto e Colabore',
  Pessoal = 'Produto Pessoal',
}

export enum Status {
  Default = '3 - Aguardando',
  Pessoal = 'Aguardando Priorizacao',
  PadraoNeoassist = 'Novo'
}

export enum Justificativa {
  Default = 'Análise Desenvolvimento',
  Pessoal = 'A Analisar',
}

export enum Categoria {
  Pessoal = '583254',
  Rh = '583236',
}
export interface solicitante {
  id :string,
  nome:string,
  email:string,
  cpfFieldU:string,
  protocoloFieldH:string
}

export interface Imagens {
  Nome:string;
  Base64:string;
}

const InicializaTicket = () => {
  return {
    tipo: 2,
    protocolo: '',
    chamado: '',
    titulo: '',
    solicitanteId: '',
    problema: '',
    propostaDeSolucao: '',
    custoSeNaoImplementado: '',
    embasamento: '',
    categoria: 'Solicitação',
    urgencia: 'Média',
    status: Status.PadraoNeoassist,
    abertura: dataAtual.toString(),
    equipeResponsavel: Equipe.Default,
    justificativa: Justificativa.Default,
    solicitante: null,
    modulo:0,
    
    //Novos campos neoassist
    idCategoria:Categoria.Rh,
    image: []    
  }

}

export default InicializaTicket;